import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink, IMultipleEntitiesResponse } from "@/types"
import StocktakingOrder, { IGetStocktakingOrderDto, IStocktakingOrderAdditionalParams } from "./StocktakingOrder"

export default class StocktakingOrders {
    items: StocktakingOrder[]
    linkCreate?: IApiLink

    constructor(dto: IMultipleEntitiesResponse<IGetStocktakingOrderDto>, stocktakingOrderAdditionalParams: IStocktakingOrderAdditionalParams) {
        this.items = dto.entities.map(e => new StocktakingOrder(e, stocktakingOrderAdditionalParams))
        this.linkCreate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.stocktakingOrder && lnk.rel === ApiLinkRel.new)
    }
}
